import {event} from './event';
import {venue} from './venue';
import {partner} from './partner';
import {priceLevel} from './price-levels';
import {products} from './products';
import {reservation} from './reservation';
import {tickets} from './tickets';
import {productSales} from './product-sales';
import {bundleSales} from './bundle-sales';
import {ticketPicker} from '../views/ticket-picker/reducers/ticket-picker';
import {productPicker} from '../views/product-picker/reducers/product-picker';
import {bundlePicker} from '../views/bundle-picker/reducers/bundle-picker';
import {member} from '../views/member/reducers/member';
import {delivery} from '../views/delivery/reducers/delivery';
import {questions} from '../views/questions/reducers/questions';
import {coupon} from '../views/coupon/reducers/coupon';
import {eventSeries} from '../views/series/reducers/event-series';
import {donations} from '../views/donations/reducers/donations';
import {ui} from './ui';
import {payment} from './payment';
import {confirmation} from './confirmation';
import {bundles} from './bundles';
import {hooks} from './hooks';
import {loading} from './loading';
import {insurance} from '@v/insurance/reducers/insurance';
import {fees} from './fees';
import {timeout} from '../views/timeout-prompt/reducers/timeout';
import {intl} from './intl';
import {contactInfo} from './contact-info';
import {socialSettings} from './socialSettings';
import {keyboard} from './keyboard';
import {time} from '../views/time/reducers/time';
import {settings} from './settings';
import {kioskManagement} from '../../listing/views/kiosk-management/reducers/kioskManagement';
import {inventoryFilter} from '../views/series/reducers/inventory-filter';
import {livestream} from './livestream';

export default {
    event,
    venue,
    partner,
    priceLevel,
    products,
    productSales,
    productPicker,
    ticketPicker,
    bundleSales,
    reservation,
    tickets,
    ui,
    member,
    delivery,
    payment,
    confirmation,
    questions,
    bundles,
    bundlePicker,
    hooks,
    coupon,
    loading,
    eventSeries,
    fees,
    insurance,
    timeout,
    intl,
    contactInfo,
    donations,
    socialSettings,
    keyboard,
    time,
    settings,
    kioskManagement,
    inventoryFilter,
    livestream,
};
